// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 빈 목록
//
//  ★★★ 이 컴포넌트가 존재하는 이유는 **문구 하나** 때문이다 ★★★
//
//    **「없습니다」라고 쓰지 마라.**
//
//  설계상 비멤버에게는 403 이 아니라 **404** 를 준다(DB-DESIGN §7-5). 403 을 주면
//  그 응답 자체가 "그 현장은 존재한다" 는 확인이 되기 때문이다. 그래서 서버 입장에서
//  아래 넷은 **바이트 단위로 같은 응답**이고, 화면은 그 둘을 **구분할 수 없다**:
//
//      · 정말로 아무 데도 초대되지 않았다
//      · 현장은 있는데 내가 구성원이 아니다
//      · 지워진 현장이다
//      · 없는 주소다
//
//  → "현장이 없습니다" 는 **거짓말이 될 수 있다.** 실제로는 초대만 받으면 되는 사람에게
//    "없다" 고 말해서 돌려보내는 것이고, 그 사람은 다시 오지 않는다.
//  → 언제나 **「볼 수 있는 것이 없다」 + 「무엇을 하면 되는지」 + 연락처** 셋을 같이 쓴다.
//
//  ⚠️ `action` 을 빼먹지 마라. 「볼 수 있는 것이 없다」만 있고 다음 행동이 없으면
//     그건 그냥 막다른 길이다. 연락처는 이 컴포넌트가 알아서 항상 붙인다.
// ─────────────────────────────────────────────────────────────────────────

import { Card, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { Contact } from './Contact';

export function EmptyState({
  /** 예: 「볼 수 있는 현장이 없습니다.」 — **「없습니다」로 끝내지 말 것**(위 머리말) */
  headline,
  /** 왜 비어 있을 수 있는지. 가능성을 **여러 개** 적어라. 화면은 어느 쪽인지 모른다. */
  children,
  /** 다음 행동. 버튼이면 `<Button>` 을, 없으면 생략. */
  action,
  /** 연락처 앞에 붙일 말. 화면마다 요청 내용이 다르다. */
  contactPrefix = '초대 요청·문의',
}: {
  headline: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  contactPrefix?: string;
}) {
  return (
    <Card padding="lg">
      <Stack gap="md" className="cv-measure">
        {/* 16px 이상 · 굵게. 야외 A 등급이다 — 이 줄을 못 읽으면 나머지를 안 읽는다. */}
        <Title order={3}>{headline}</Title>
        {children ? (
          <Text size="md" c="var(--cv-ink-2)">
            {children}
          </Text>
        ) : null}
        {action ? <div className="cv-touchrow">{action}</div> : null}
        <Contact prefix={contactPrefix} />
      </Stack>
    </Card>
  );
}
